// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 582) return "../css/7.0.31596-listing-favorite.min.css";
	if (chunkId === 521) return "../css/7.0.31596-listing-notes.min.css";
	if (chunkId === 548) return "../css/7.0.31596-listing-rate.min.css";
	if (chunkId === 67) return "../css/7.0.31596-request-service-form.min.css";
	if (chunkId === 7) return "../css/7.0.31596-request-register-form.min.css";
	// return url for filenames based on template
	return undefined;
};